import { FaShoppingCart, FaTimesCircle, FaUndo } from "react-icons/fa";
import PurchaseRequest from "../components/his/inventory/PurchaseRequest";
import PurchaseReports from "../components/his/inventory/Reports/PurchaseReports";
import Requisition from "../components/his/inventory/Requisition";
import GoodReceiptList from "../components/his/inventory/stock/GoodReceiptList";
import StockList from "../components/his/inventory/stock/StockList";
import SubstoreReturn from "../components/his/inventory/SubstoreReturn";
import WriteOff from "../components/his/inventory/WriteOff";
import WriteOffList from "../components/his/inventory/WriteOffList";
import { formatDate } from "../utils/FormateDateTime";
import { sequenceTableTemplate } from "../utils/squenceTableNo";
import { FaChartBar } from "react-icons/fa";
import { MdOutlineRadioButtonChecked } from "react-icons/md";
import StockReport from "../components/his/inventory/Reports/StockReport";
import SupplierReport from "../components/his/inventory/Reports/SupplierReport";
import ReturnToVendor from "../components/his/inventory/ReturnToVendor";
import Donate from "../components/his/inventory/Donate";

export const Inventorytabs = (t) => [
  {
    name: t("Internal"),
    isDisabled: true,
    children: [
      {
        name: t("WriteoffItemsList"),
        content: <WriteOffList />,
      },
      {
        name: t("Requisition"),
        content: <Requisition />,
      },
      {
        name: t("ReturnfromSubstore"),
        content: <SubstoreReturn />,
      },
      {
        name: t("PurchaseRequest"),
        content: <PurchaseRequest />,
      },
      {
        name: t("Writeoff"),
        content: <WriteOff />,
      },
    ],
  },
  {
    name: t("Stock"),
    children: [
      { name: t("StockList"), content: <StockList /> },
      { name: t("GoodsReceiptlist"), content: <GoodReceiptList /> },
    ],
  },
  {
    name: t("Reports"),
    children: [
      { name: t("Purchase"), content: <PurchaseReports /> },
      { name: t("Stock"), content: <StockReport /> },
      { name: t("Supplier"), content: <SupplierReport /> },
    ],
  },
  {
    name: t("ReturntoVendor"),
    content: <ReturnToVendor />,
  },
  { name: t("Donate"), content: <Donate /> },
];

export const WriteOffColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "item_name",
    header: t("ItemName"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "write_off_qty",
    header: t("WriteOffQty"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "write_off_date",
    header: t("WriteOffDate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "rate",
    header: t("Rate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "total_amount",
    header: t("TotalAmount"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "warehouse",
    header: t("Warehouse"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "approver",
    header: t("Approver"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "writeOffType",
    header: t("Write-off Type"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "reason",
    header: t("Reason"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "remark",
    header: t("Remark"),
    headerCellClass: "!bg-gray-200",
  },
];

export const dummyWriteOffData = [
  {
    item_name: "Paracetamol 500mg",
    write_off_qty: 50,
    unit: "Tablets",
    write_off_date: "2024-03-15",
    rate: 2.5,
    total_amount: 125.0,
    remark: "Expired stock",
  },
  {
    item_name: "Surgical Gloves",
    write_off_qty: 200,
    unit: "Pairs",
    write_off_date: "2024-03-14",
    rate: 1.2,
    total_amount: 240.0,
    remark: "Damaged packaging",
  },
  {
    item_name: "IV Saline 500ml",
    write_off_qty: 30,
    unit: "Bottles",
    write_off_date: "2024-03-13",
    rate: 15.0,
    total_amount: 450.0,
    remark: "Leakage found",
  },
];
export const RedColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "store_name",
    header: t("StoreName"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "red_date",
    header: t("RedDate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "requested_by",
    header: t("RequestedBy"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "received_by",
    header: t("ReceivedBy"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "status",
    header: t("Status"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "verification_status",
    header: t("VerificationStatus"),
    headerCellClass: "!bg-gray-200",
  },
];

export const dummyRedData = [
  {
    store_name: "Store A",
    red_date: "2025-03-19",
    requested_by: "Tayab Mohammed",
    received_by: "Ibrahim farouk ",
    status: "Completed",
    verification_status: "Verified",
  },
  {
    store_name: "Store B",
    red_date: "2025-03-18",
    requested_by: "Alice Johnson",
    received_by: "Bob Brown",
    status: "Pending",
    verification_status: "Pending",
  },
  {
    store_name: "Store C",
    red_date: "2025-03-17",
    requested_by: "Charlie Davis",
    received_by: "Eve White",
    status: "In Progress",
    verification_status: "Unverified",
  },
];
export const DispatchItemColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "itemCategory",
    header: t("ItemCategory"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "itemName",
    header: t("ItemName"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "code",
    header: t("Code"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "unit",
    header: t("Unit"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "availableQty",
    header: t("AvailableQty"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "dispatchedQty",
    header: t("DispatchedQty"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "remark",
    header: t("Remark"),
    headerCellClass: "!bg-gray-200",
  },
];

export const ReturnedItemsColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "returnedDate",
    header: t("ReturnedDate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "returnedBy",
    header: t("ReturnedBy"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "substoreFrom",
    header: t("SubstoreFrom"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "status",
    header: t("Status"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "receivedBy",
    header: t("ReceivedBy"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "receivedDate",
    header: t("ReceivedDate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "remarks",
    header: t("Remarks"),
    headerCellClass: "!bg-gray-200",
  },
];
export const PurchaseRequestColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "prNo",
    header: t("PRNo."),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "requestDate",
    header: t("RequestDate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "vendor",
    header: t("Vendor"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "status",
    header: t("Status"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "verificationStatus",
    header: t("VerificationStatus"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "requestedBy",
    header: t("RequestedBy"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "poCreated",
    header: t("POCreated"),
    headerCellClass: "!bg-gray-200",
  },
];
export const PRItemColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "itemCategory",
    header: t("PRCategory"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "itemName",
    header: t("ItemName"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "code",
    header: t("Code"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "uom",
    header: t("UOM"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "quantity",
    header: t("Quantity"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "availableQty",
    header: t("AvailableQty"),
    headerCellClass: "!bg-gray-200",
  },
  {
    body: (row) => {
      return formatDate(row?.quantityVerifiedOn);
    },
    header: t("QuantityVerifiedOn"),
    headerCellClass: "!bg-gray-200",
  },
  {
    body: (row) => {
      return formatDate(row?.supplyRequiredBefore);
    },
    header: t("SupplyRequiredBefore"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "remark",
    header: t("ItemRemark"),
    headerCellClass: "!bg-gray-200",
  },
];
export const WriteOffItemColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "itemName",
    header: t("ItemName"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "code",
    header: t("Code"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "availableQty",
    header: t("AvailableQty"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "writeOffQty",
    header: t("Write-offQty"),
    headerCellClass: "!bg-gray-200",
  },
  {
    body: (row) => {
      return formatDate(row?.writeOffDate);
    },
    header: t("Write-offDate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "remark",
    header: t("Remark"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "itemRate",
    header: t("ItemRate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "subTotal",
    header: t("SubTotal"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "vatPercent",
    header: t("VAT%"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "totalAmount",
    header: t("TotalAmount"),
    headerCellClass: "!bg-gray-200",
  },
];
export const ItemInventoryColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "itemType",
    header: t("ItemType"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "subCategory",
    header: t("SubCategory"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "itemName",
    header: t("ItemName"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "itemCode",
    header: t("ItemCode"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "unit",
    header: t("Unit"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "availableQuantity",
    header: t("AvailableQuantity"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "minimumQuantity",
    header: t("MinimumQuantity"),
    headerCellClass: "!bg-gray-200",
  },
];

export const InventoryItemsData = [
  {
    itemType: "Consumable",
    subCategory: "Medicines",
    itemName: "Aspirin",
    itemCode: "ABC123",
    unit: "Box",
    availableQuantity: 1000,
    minimumQuantity: 500,
  },
];
export const GRColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "grDate",
    header: t("GRDate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "poNo",
    header: t("PONo."),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "vendorBillDate",
    header: t("VendorBillDate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "vendorName",
    header: t("VendorName"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "vendorContact",
    header: t("VendorContact"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "billNo",
    header: t("BillNo."),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "totalAmount",
    header: t("TotalAmount"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "payMode",
    header: t("PayMode"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "remarks",
    header: t("Remarks"),
    headerCellClass: "!bg-gray-200",
  },
];
export const PurchaseReportsData = (t) => [
  {
    title: t("PurchaseOrder"),
    icon: <FaShoppingCart className="text-primary" size={20} />,
  },
  {
    title: t("CancelledPOandGR"),
    icon: <FaTimesCircle className="text-primary" size={20} />,
  },
  {
    title: t("PurchaseItems"),
    icon: <FaShoppingCart className="text-primary" size={20} />,
  },
  {
    title: t("PurchaseSummary"),
    icon: <FaShoppingCart className="text-primary" size={20} />,
  },
  {
    title: t("ReturnToSupplier"),
    icon: <FaUndo className="text-primary" size={20} />,
  },
];
export const SupplierReportsData = (t) => [
  {
    title: t("SupplierWiseStock"),
    icon: <FaChartBar className="text-primary" size={20} />,
  },
  {
    title: t("SupplierInformationReport"),
    icon: <MdOutlineRadioButtonChecked className="text-primary" size={20} />,
  },
];

export const stockReportsData = (t) => [
  {
    title: t("CurrentStockLevel"),
    icon: <FaChartBar className="text-primary" size={20} />,
  },
  {
    title: t("InventorySummary"),
    icon: <FaShoppingCart className="text-primary" size={20} />,
  },
  {
    title: t("SubstoreDispatchAndConsumption"),
    icon: <FaShoppingCart className="text-primary" size={20} />,
  },
  {
    title: t("DetailStockLedger"),
    icon: <MdOutlineRadioButtonChecked className="text-primary" size={20} />,
  },
  {
    title: t("ExpiryItem"),
    icon: <MdOutlineRadioButtonChecked className="text-primary" size={20} />,
  },
  {
    title: t("IssuedItemList"),
    icon: <MdOutlineRadioButtonChecked className="text-primary" size={20} />,
  },
  {
    title: t("ExpirableStock"),
    icon: <MdOutlineRadioButtonChecked className="text-primary" size={20} />,
  },
  {
    title: t("OpeningStockValuation"),
    icon: <MdOutlineRadioButtonChecked className="text-primary" size={20} />,
  },
  {
    title: t("SubstoreWiseSummary"),
    icon: <FaChartBar className="text-primary" size={20} />,
  },
];
export const returnToVenderColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("No"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "vendorName",
    header: t("VendorName"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "creditNoteNo",
    header: t("CreditNoteNo"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "returnedOn",
    header: t("ReturnedOn"),
    headerCellClass: "!bg-gray-200",
  },
];
export const DonationColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("S.N"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "donationNo",
    header: t("DonationNo"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "donatedTo",
    header: t("DonatedTo"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "donationDate",
    header: t("DonationDate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "donationRefNo",
    header: t("DonationRefNo"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "donationRefDate",
    header: t("DonationRefDate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "totalValue",
    header: t("TotalValue"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "username",
    header: t("Username"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "remarks",
    header: t("Remarks"),
    headerCellClass: "!bg-gray-200",
  },
];
export const DonationItemColumns = (t) => [
  {
    body: sequenceTableTemplate,
    header: t("S.N"),
    style: { width: "3rem" },
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "itemCategory",
    header: t("ItemCategory"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "itemName",
    header: t("ItemName"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "specification",
    header: t("Specification"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "itemCode",
    header: t("ItemCode"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "modelNo",
    header: t("ModelNo"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "unit",
    header: t("Unit"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "availableQty",
    header: t("AvailableQty"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "costPrice",
    header: t("CostPrice"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "donationQty",
    header: t("DonationQty"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "totalValue",
    header: t("TotalValue"),
    headerCellClass: "!bg-gray-200",
  },
  {
    body: (row) => {
      return formatDate(row?.grDate);
    },
    header: t("GRDate"),
    headerCellClass: "!bg-gray-200",
  },
  {
    field: "remarks",
    header: t("Remarks"),
    headerCellClass: "!bg-gray-200",
  },
];
